var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('observer',{staticClass:"svg-anim",attrs:{"threshold":[0.5],"data-size":_vm.size || 'cover',"log":true},domProps:{"innerHTML":_vm._s(_vm.svgCode)},on:{"ratio":_vm.onVisibility}})}
var staticRenderFns = []

export { render, staticRenderFns }